import React from 'react';
import './afterpay.scss';

const AfterPayMessaging = (props) => {
  var showAfterPay = props.passedAppFunctions.wasParms.useAfterpay;
  var afterpayMaxAmt = props.passedAppFunctions.wasParms.afterpayMaxOrderAmt;
  var maxPrice = 0;
  var isGiftCard = false;
  if (props.pricing) {
    maxPrice = props.pricing.offerPriceMax;
    isGiftCard = props.pricing.dept == '0968';
  }

  return (
    <>
      {showAfterPay == 'true' &&
      !isGiftCard &&
      (typeof window == 'undefined' || props.passedAppFunctions.country == 'US') &&
      Number(maxPrice.split(',').join('')) <= Number(afterpayMaxAmt) &&
      maxPrice != 0 ? (
        <>
          {
            <div className='afterPayMessaging'>
              <div className='overlay' id='overlay'></div>
              {/* <afterpay-placement data-locale='en_US' data-currency='USD' data-badge-theme='black-on-white' data-amount={maxPrice}></afterpay-placement> */}
              <afterpay-placement
                data-locale='en_US'
                data-currency='USD'
                data-badge-theme='black-on-white'
                data-amount={maxPrice}
                data-max='3000'
                data-min='1'
                data-show-lower-limit='true'
              ></afterpay-placement>
            </div>
          }
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default AfterPayMessaging;
